import { render, staticRenderFns } from "./WmButtonGroup.vue?vue&type=template&id=7915dd6f&scoped=true"
import script from "./WmButtonGroup.vue?vue&type=script&lang=js"
export * from "./WmButtonGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7915dd6f",
  null
  
)

export default component.exports